import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { Box, Typography } from '@mui/material';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
/* ─── design tokens (matches project theme) ──────────────────────────────── */
const PINK = '#FF008E';
const SURFACE = '#FFFFFF';
const BORDER = '#E9EAEB';
const T1 = '#181D27';
const T2 = '#717680';
/* ─────────────────────────────────────────────────────────────────────────── */
export default function AccessRestrictedContent() {
    const [mounted, setMounted] = useState(false);
    const [checkAnim, setCheckAnim] = useState(false);
    useEffect(() => {
        const t1 = setTimeout(() => setMounted(true), 80);
        const t2 = setTimeout(() => setCheckAnim(true), 500);
        return () => { clearTimeout(t1); clearTimeout(t2); };
    }, []);
    return (_jsx(Box, { sx: {
            width: '100%',
            maxWidth: 400,
            mx: 'auto',
            opacity: mounted ? 1 : 0,
            transform: mounted ? 'translateY(0)' : 'translateY(24px)',
            transition: 'opacity 0.5s ease, transform 0.5s ease',
        }, children: _jsxs(Box, { sx: { textAlign: 'center', mb: 3.5 }, children: [_jsxs(Box, { sx: { display: 'inline-flex', position: 'relative', mb: 2.5 }, children: [_jsx(Box, { sx: {
                                position: 'absolute',
                                inset: -8,
                                borderRadius: '50%',
                                border: `1.5px solid ${PINK}`,
                                opacity: checkAnim ? 0 : 0.5,
                                transform: checkAnim ? 'scale(1.5)' : 'scale(1)',
                                transition: 'opacity 0.8s 0.6s ease, transform 0.8s 0.6s ease',
                                pointerEvents: 'none',
                            } }), _jsx(Box, { sx: {
                                width: 72,
                                height: 72,
                                borderRadius: '50%',
                                backgroundColor: checkAnim ? PINK : SURFACE,
                                border: `2px solid ${checkAnim ? PINK : BORDER}`,
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                transition: 'background-color 0.4s ease, border-color 0.4s ease',
                                boxShadow: checkAnim
                                    ? `0 0 0 6px #ffe6f3, 0 8px 24px ${PINK}33`
                                    : 'none',
                            }, children: _jsx(LockOutlinedIcon, { sx: {
                                    color: checkAnim ? 'white' : PINK,
                                    fontSize: 32,
                                    transition: 'color 0.4s ease'
                                } }) })] }), _jsx(Typography, { sx: {
                        fontWeight: 700,
                        color: T1,
                        lineHeight: 1.2,
                        letterSpacing: '-0.4px',
                        mb: 1.5,
                    }, className: "head-Font-Sizes", children: "Access Restricted." }), _jsx(Typography, { sx: { fontSize: '0.95rem', color: T2, lineHeight: 1.6 }, children: "You don't have permission to view this page. Please contact your administrator to request access." })] }) }));
}
